// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"21":"88a6c48a","36":"d00aafde","49":"64df6a18","187":"b723dc30","512":"6784f317","541":"a8570301","654":"d00aafde"}[chunkId] + ".css";
};